/*
  Chrome redirects to the action of the form when the submit button is clicked.
  This module disables the submit buttons to prevent multiple submissions.

  Action of the form url return an error page.
*/

const init = () => {
	const forms = document.querySelectorAll('[js-module~="profileSwitch"]');

	if (!forms) return;

	forms.forEach((form) => {
		form.addEventListener('submit', () => disableSubmitButtons(form));
	});
};

const disableSubmitButtons = (form) => {
	const submitButtons = form.querySelectorAll(
		'[js-element~="profileSwitchAvatar"]'
	);

	submitButtons.forEach((button) => {
		button.disabled = true;
		button.ariaDisabled = true;
	});
};

export default {
	init,
};
